import { z } from 'zod';
import { VISIBLE_SLOTS } from '../rules/appearance.js';
/**
 * What `appearanceOf` answers, as a portrait (character list, party frames)
 * carries it: the visible slots and the footstep trail (ADR 0073). Strict
 * keys, so it must name every key `Appearance` has: a key missing here makes
 * every response that carries it fail to parse, sign-in included.
 */
export const AppearanceSchema = z.partialRecord(z.enum([...VISIBLE_SLOTS, 'trail']), z.string().min(1));
//# sourceMappingURL=appearance.js.map